import Api from "./Api.js";
const resource = "prints";

export default {
  checkPrintLock() {
    return Api.get(`/${resource}/lock`);
  }
};
